<template>
    <pageWithNav>
        <el-dialog title="Add Sticky Note" :visible.sync="visible" width="420px" :close-on-click-modal="true">
            <div class="section">
                <el-input type="textarea" :rows="4" v-model="stickyNoteText"
                    placeholder="Enter your sticky note text here..." />

                <div class="section-help">
                    Stick a note directly to your workflow to explain or document it on the canvas.
                </div>
            </div>

            <span slot="footer">
                <el-button @click="toggleStickyNotesMETHOD(false)">
                    Cancel
                </el-button>
                <el-button type="primary" :disabled="!stickyNoteText.trim()" @click="addStickyNote">
                    Add Sticky Note
                </el-button>
            </span>
        </el-dialog>
    </pageWithNav>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import pageWithNav from "./pageWithNav.vue";

export default {
    name: "StickyNotes",

    components: {
        pageWithNav
    },

    props: {
        workflowCanvas: {
            type: [Object, HTMLCanvasElement],
            required: true
        }
    },

    data() {
        return {
            stickyNoteText: "",
        };
    },

    computed: {
        ...mapGetters([
            "showStickyNotes",
            "getSelectedWorkflowVersion",
        ]),

        visible: {
            get() {
                return this.showStickyNotes;
            },
            set(val) {
                this.toggleStickyNotesMETHOD(val);
            }
        },
    },

    methods: {
        ...mapActions([
            "toggleStickyNotesMETHOD",
            "fetchWorkflowVersionsMETHOD",
            "returnSpecificWorkflowMETHOD"
        ]),

        async addStickyNote() {
            try {
                const storedVersion = this.getSelectedWorkflowVersion(
                    this.$route.params.workflowId
                );

                const result = await this.returnSpecificWorkflowMETHOD({
                    workflowId: this.$route.params.workflowId,
                    versionId: storedVersion,
                });

                const response = await this.$store.dispatch(
                    "addStickyNoteToWorkflowMETHOD",
                    {
                        workflowId: this.$route.params.workflowId,
                        versionId: storedVersion,
                        description: this.stickyNoteText,
                        workflowLastUpdated: result?.updatedAt,
                    }
                );

                if (!response?.error) {
                    this.stickyNoteText = "";
                    this.toggleStickyNotesMETHOD(false);
                    this.$emit("refresh-workflow");

                    this.$notify({
                        title: "Success",
                        message: "Sticky note added to the workflow",
                        type: "success",
                        position: "bottom-left"
                    });
                } else {
                    throw response;
                }
            } catch (e) {
                this.$notify({
                    title: "Error",
                    message: e?.error?.message || "Failed to add sticky note",
                    type: "error",
                    position: "bottom-left"
                });
            }
        },
    }
};
</script>

<style scoped>
.section-help {
    font-size: 12px;
    color: #6b7280;
    margin-top: 6px;
    text-align: left;
}
</style>
